import { STATUS_LABELS } from "@/lib/api";

const STYLES = {
  idea: "bg-white/10 text-white/70 border-white/20",
  scenario: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  approved: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  quoted: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  in_production: "bg-gold/15 text-gold border-gold/40",
  delivered: "bg-emerald-600/20 text-emerald-400 border-emerald-500/40",
  completed: "bg-emerald-600/25 text-emerald-300 border-emerald-500/50",
};

export function StatusBadge({ status, testid }) {
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs uppercase tracking-wider border ${STYLES[status] || STYLES.idea}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
